import React from 'react';
import Events from './Events';
import '../../CommonCSS/SocietyCSS.css';

const EventsApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Events </h5>
          </div>
        </div>
        <Events/>
      </div>
    </div >
  );
};

export default EventsApp;
